const skills = {
    1:[ {
        title: "HTML",
        level: 6
        },
        {
        title: "CSS",
        level: 5
        },
        {
        title: "ANGULAR",
        level: 4
        },
        {
        title: "JAVASCRIPT",
        level: 3
        },
        {
        title: "WORDPRESS",
        level: 6
        },
        {
        title: "REACT JS",
        level: 3
        },
        {
        title: "ELECTRON",
        level: 5
        },
    ],
    
    2:[ {
        title: "PYTHON",
        level: 5
        },
        {
        title: "MACRO VBA",
        level: 4
        },
        {
        title: "RPA",
        level: 5
        },
        {
        title: "MONGODB",
        level: 3
        },
        {
        title: "MYSQL",
        level: 3
        },
        {
        title: "PHP",
        level: 1
        },
        {
        title: "NODE JS",
        level: 3
        },
    ]
}

export default skills;